module.exports = __webpack_public_path__ + "media/src/assets/Images/Administration-5ac0c1754dd6a74fcb22aab868bfa453.svg";